/*
 * ******************************************************
 * Copyright (c) 2022 Jenke & Rauschert GbR <info@aiandor.de> - All Rights Reserved
 *
 * This file is part of a software product owned by the Jenke & Rauschert GbR.
 * Unauthorized distribution of this file is strictly prohibited.
 * ******************************************************
 */

import ReactDOM from "react-dom";
import App from './app';
import dayjs from "dayjs";
dayjs.locale('de')

ReactDOM.render(<App/>, document.getElementById('root'));
